import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  CalendarItem,
  ButtonItem,
  SelectEmbudosItem,
} from "../../../../Components/Items";
import { EyeInvisibleOutlined, EyeOutlined, PlusOutlined, ProjectOutlined } from "@ant-design/icons";
import { PageHeader, Select, Tooltip } from "antd";
import ModalTarea from "../Components/ModalTarea";
import axios from "axios";
import IconCalendarCancel from "../../../../Icons/IconCalendarCancel";
import DrawerEventsList from "../../../../Components/DrawerEventsList";
import EventDetailDrawer from "../../../../Components/EventDetailDrawer";
import SelectLeadsItem from "../../../../Components/SelectLeadsItem";

const { Option } = Select;

class CalendarioRecordatorios extends Component {
  state = {
    eventos: [],
    loading: false,
    modalVisible: false,
    tareaEditando: null,
    drawerSinFechaVisible: false,
    eventosSinFecha: [],
    cargandoSinFecha: false,
    detailDrawerVisible: false,
    eventoSeleccionado: null,
    // Filtros
    filtroLeadId: null,
    filtroEmbudoId: null,
    mostrarCompletadas: false,
    // Filtro vendedor (solo master)
    filtroUsuarioId: null,
    usuariosEmpresa: [],
    rangoActual: {
      start: moment().startOf("month").toDate(),
      end: moment().endOf("month").toDate(),
    },
  };

  componentDidMount() {
    if (this.props.permisoMasterCRM) {
      this.cargarUsuariosEmpresa();
    }
    const hoy = moment();
    this.cargarEventos(
      hoy.clone().startOf("month").toDate(),
      hoy.clone().endOf("month").toDate(),
    );
  }

  cargarUsuariosEmpresa = () => {
    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ usuariosEmpresa: res.data });
        }
      })
      .catch(() => {});
  };

  cargarEventos = (start, end) => {
    const { headersToken, empresaId, permisoMasterCRM } = this.props;
    const { filtroUsuarioId } = this.state;

    this.setState({ cargando: true });

    axios
      .post(
        "/tareas/selectTareasCalendario",
        {
          empresaId,
          start,
          end,
          ...(permisoMasterCRM
            ? { vendedorId: filtroUsuarioId ?? "todos" }
            : {}),
        },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data?.success === 2) {
          const eventos = res.data.eventos.map((e) => ({
            ...e,
            start: new Date(e.start),
            end: new Date(e.end),
          }));
          this.setState({ eventos });
        }
      })
      .catch((error) => {
        console.error("Error al cargar eventos del calendario:", error);
      })
      .finally(() => {
        this.setState({ cargando: false });
      });
  };

  cargarEventosSinFecha = () => {
    const { headersToken, empresaId, permisoMasterCRM } = this.props;
    const { filtroUsuarioId } = this.state;
    this.setState({ cargandoSinFecha: true });

    axios
      .post(
        "/tareas/selectSinFecha",
        {
          empresaId,
          ...(permisoMasterCRM
            ? { vendedorId: filtroUsuarioId ?? "todos" }
            : {}),
        },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data?.success === 2) {
          this.setState({ eventosSinFecha: res.data.eventos });
        }
      })
      .catch((err) => console.error(err))
      .finally(() => this.setState({ cargandoSinFecha: false }));
  };

  getEventosFiltrados = () => {
    const { eventos, filtroLeadId, filtroEmbudoId, mostrarCompletadas } = this.state;

    return eventos.filter((e) => {
      if (!mostrarCompletadas && e.completado) return false;
      if (filtroLeadId && e.leadId?.toString() !== filtroLeadId.toString())
        return false;
      if (
        filtroEmbudoId &&
        e.embudoId?.toString() !== filtroEmbudoId.toString()
      )
        return false;
      return true;
    });
  };

  handleAbrirSinFecha = () => {
    this.setState({ drawerSinFechaVisible: true });
    this.cargarEventosSinFecha();
  };

  handleRangeChange = (range) => {
    let start, end;

    if (Array.isArray(range)) {
      start = range[0];
      end = moment(range[range.length - 1])
        .endOf("day")
        .toDate();
    } else {
      start = range.start;
      end = range.end;
    }

    this.setState({ rangoActual: { start, end } });
    this.cargarEventos(start, end);
  };

  handleTareaGuardada = () => {
    const { rangoActual } = this.state;
    this.cargarEventos(rangoActual.start, rangoActual.end);
  };

  handleEditarEvento = (evento) => {
    this.setState({ tareaEditando: evento, modalVisible: true });
  };

  handleCerrarModal = () => {
    this.setState({ modalVisible: false, tareaEditando: null });
  };

  onChangeUsuarioFiltro = (id) => {
    this.setState({ filtroUsuarioId: id ?? null }, () => {
      const { rangoActual } = this.state;
      this.cargarEventos(rangoActual.start, rangoActual.end);
    });
  };

  render() {
    const { loading, modalVisible, usuariosEmpresa, filtroUsuarioId } = this.state;
    const { permisoMasterCRM } = this.props;
    const eventosFiltrados = this.getEventosFiltrados();

    return (
      <>
        <PageHeader
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Tooltip title="Ir al tablero">
                <ProjectOutlined
                  onClick={() => this.props.history.push("/panel/crmDashboard")}
                  style={{ fontSize: 16, color: "#bbb", cursor: "pointer" }}
                />
              </Tooltip>
              Calendario de Tareas
            </div>
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 15,
          }}
          extra={
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <Tooltip
                title={
                  this.state.mostrarCompletadas
                    ? "Ocultar completadas"
                    : "Mostrar completadas"
                }
              >
                <ButtonItem
                  lima={!this.state.mostrarCompletadas}
                  blanco={this.state.mostrarCompletadas}
                  className="botonAgregar"
                  icon={!this.state.mostrarCompletadas ? <EyeOutlined /> : <EyeInvisibleOutlined/>}
                  onClick={() =>
                    this.setState((prev) => ({
                      mostrarCompletadas: !prev.mostrarCompletadas,
                    }))
                  }
                />
              </Tooltip>

              {permisoMasterCRM && (
                <Select
                  placeholder="Ver tareas de..."
                  style={{ width: 200 }}
                  allowClear
                  showSearch
                  filterOption={(input, opt) =>
                    opt.children.toLowerCase().includes(input.toLowerCase())
                  }
                  value={filtroUsuarioId ?? undefined}
                  onChange={this.onChangeUsuarioFiltro}
                >
                  {usuariosEmpresa.map((u) => (
                    <Option key={u._id} value={u._id}>
                      {`${u.nombre} ${u.apellidoPaterno ?? ""}`.trim()}
                    </Option>
                  ))}
                </Select>
              )}

              <SelectEmbudosItem
                headersToken={this.props.headersToken}
                empresaId={this.props.empresaId}
                placeholder="Filtrar por embudo..."
                style={{ width: 200 }}
                value={this.state.filtroEmbudoId}
                onChange={(id) => this.setState({ filtroEmbudoId: id ?? null })}
                allowClear
              />

              <SelectLeadsItem
                headersToken={this.props.headersToken}
                empresaId={this.props.empresaId}
                placeholder="Filtrar por lead..."
                style={{ width: 200 }}
                value={this.state.filtroLeadId}
                onChange={(id) => this.setState({ filtroLeadId: id ?? null })}
                allowClear
              />
              <ButtonItem
                key="sin-fecha"
                className="botonAgregar"
                rosa
                onClick={this.handleAbrirSinFecha}
                icon={<IconCalendarCancel />}
              >
                Ver tareas sin fecha
              </ButtonItem>

              <ButtonItem
                className="botonAgregar"
                azul
                icon={<PlusOutlined />}
                onClick={() => this.setState({ modalVisible: true })}
              >
                Nueva tarea
              </ButtonItem>
            </div>
          }
        />

        <CalendarItem
          events={eventosFiltrados}
          loading={loading}
          onRangeChange={this.handleRangeChange}
          onActualizado={this.handleTareaGuardada}
          onEditarEvento={this.handleEditarEvento}
        />
        <ModalTarea
          visible={modalVisible}
          tareaEditando={this.state.tareaEditando}
          onCancel={this.handleCerrarModal}
          onGuardado={this.handleTareaGuardada}
        />

        <DrawerEventsList
          visible={this.state.drawerSinFechaVisible}
          titulo="Tareas sin fecha"
          eventos={this.state.eventosSinFecha}
          cargando={this.state.cargandoSinFecha}
          emptyText="No hay tareas sin fecha"
          onClose={() => this.setState({ drawerSinFechaVisible: false })}
          onEventoClick={(evento) => {
            this.setState({
              drawerSinFechaVisible: false,
              detailDrawerVisible: true,
              eventoSeleccionado: evento,
            });
          }}
        />
        <EventDetailDrawer
          visible={this.state.detailDrawerVisible}
          evento={this.state.eventoSeleccionado}
          onClose={() =>
            this.setState({
              detailDrawerVisible: false,
              eventoSeleccionado: null,
            })
          }
          onEditar={(evento) => {
            this.setState({ detailDrawerVisible: false });
            this.handleEditarEvento(evento);
          }}
          onActualizado={() => {
            this.cargarEventosSinFecha();
            this.handleTareaGuardada();
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoMasterCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a170cabe0d8ec48005e197f",
    )?.activado,
});

export default connect(mapStateToProps)(CalendarioRecordatorios);
